import React from 'react';
import { ArrowRightOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import colors from '../constants/Colors';

export default function BoardSearchArrow({ highlight }) {
  const { settings = {} } = useSelector((state) => state.settings.company);
  const hasRedesign = settings?.uxRedesignPt1;
  if (!highlight) return null;
  return (
    <div
      className="board-search-arrow-container"
    >
      <ArrowRightOutlined
        className="board-search-arrow"
        style={{
          color: hasRedesign ? colors.REDESIGN_PRIMARY : colors.ONTRACCR_RED,
          fontSize: 16,
        }}
      />
    </div>
  );
}

BoardSearchArrow.propTypes = {
  highlight: PropTypes.bool.isRequired,
};
